import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = ({ scrollToSection, setIsFrameworkModalOpen }) => {
    return (
        <footer className="dark-footer">
            <div className="footer-content">
                <div className="footer-column">
                    <div className="footer-logo">
                        <Logo size={28} />
                        <span>ADJACTIVE</span>
                    </div>
                    <p className="footer-tagline">Security for AI. Security from AI.</p>
                    <p className="footer-note">An initiative by Hakxcore</p>
                </div>

                <div className="footer-column">
                    <h4 className="footer-heading">Framework</h4>
                    <ul className="footer-links">
                        <li><button onClick={() => scrollToSection('research')}>Methodology</button></li>
                        <li><button onClick={() => setIsFrameworkModalOpen(true)}>Download Overview</button></li>
                        <li><button onClick={() => scrollToSection('research')}>How It Works</button></li>
                    </ul>
                </div>

                <div className="footer-column">
                    <h4 className="footer-heading">Resources</h4>
                    <ul className="footer-links">
                        <li><button onClick={() => scrollToSection('research')}>Research</button></li>
                        <li><a href="/blog">Blog</a></li>
                        <li><Link to="/responsible-disclosure">Responsible Disclosure</Link></li>
                        <li><a href="mailto:tech@adjactive.com">Contact</a></li>
                    </ul>
                </div>

                <div className="footer-column">
                    <h4 className="footer-heading">Legal</h4>
                    <ul className="footer-links">
                        <li><Link to="/privacy">Privacy Policy</Link></li>
                        <li><Link to="/terms">Terms of Service</Link></li>
                        <li><Link to="/security">Security</Link></li>
                    </ul>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Adjactive. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
